// Loading skeleton for the paid report page. Extracted verbatim from
// PaidReport.jsx (W2c). Same DOM, test-id, copy.
export default function ReportLoading() {
  return (
    <div className="sf-container" style={{ padding: "80px 24px" }} data-testid="paid-report-loading">
      <div className="sf-muted-text">Loading your audit…</div>
    </div>
  );
}
